// extracted by mini-css-extract-plugin
export default {"content":"BookShelf_content__fcqFZ"};